<template>
	<!-- 限时一分 -->
	<div class="xianshimianfeiBox">
		<div class="timeBox">
			<div class="timeLimit">
				<div>
					<img src="../../assets/img/xsyficon01.png" alt="" class="xsyficon01">
					<h4>限时一分</h4>
					<img src="../../assets/img/xsyficon02.png" alt="" class="xsyficon02">
				</div>
				<p class="xstime">
					<span>00</span>:<span>00</span>:<span>00</span>
					<img src="../../assets/img/xsyficon03.png" alt="" class="xsyficon03">
				</p>
			</div>
			<div class="btn_sc">
				<button @click='toCollect("yanqing")'>一键收藏订阅</button>
			</div>
		</div>
		<!-- 言情 -->
		<div class="hotBook">
			<div class="hotBookNavBar">
				<p class="hotBookTitle">言情</p>
				<div class="btn_sc">
					<!-- <button>一键收藏订阅</button> -->
				</div>
			</div>
			<div class="bookLishBox">
				<a href="#" v-for="(item,index) in yanqing" :key="index" @click="jumpBookinfo(item.book_id)">
					<div><img :src="$api.$BASE_URL_img + item.cover_image" alt="图书" /></div>
					<!-- <p class="bookName">
						<span v-for="(nameTxt,nameIndex) in item.name" v-if="nameIndex > 5 ? false : true">{{nameTxt}}</span>
					</p> -->
					<p class="jianjie">
						<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 5 ? false : true">{{jianjieTxt}}</span>
					</p>
				</a>
			</div>
		</div>
		<!-- 纯爱 -->
		<div class="hotBook">
			<div class="hotBookNavBar">
				<p class="hotBookTitle">纯爱</p>
				<div class="btn_sc">
					<button @click='toCollect("chunai")'>一键收藏订阅</button>
				</div>
			</div>
			<div class="bookLishBox">
				<a href="#" v-for="(item,index) in chunai" :key="index" @click="jumpBookinfo(item.book_id)">
					<div><img :src="$api.$BASE_URL_img + item.cover_image" alt="图书" /></div>
					<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in item.name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span></p> -->
					<p class="jianjie"><span v-for="(introduce,introduceIndex) in item.introduce" v-if="introduceIndex > 4 ? false : true">{{introduce}}</span></p>
				</a>
			</div>
		</div>
		<!-- 衍生 -->
		<div class="hotBook">
			<div class="hotBookNavBar">
				<p class="hotBookTitle">衍生</p>
				<div class="btn_sc">
					<button @click='toCollect("yansheng")'>一键收藏订阅</button>
				</div>
			</div>
			<div class="bookLishBox">
				<a href="#" v-for="(item,index) in yansheng" :key="index" @click="jumpBookinfo(item.book_id)">
					<div><img :src="$api.$BASE_URL_img + item.cover_image" alt="图书" /></div>
					<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in item.name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span></p> -->
					<p class="jianjie"><span v-for="(introduce,introduceIndex) in item.introduce" v-if="introduceIndex > 4 ? false : true">{{introduce}}</span></p>
				</a>
			</div>
		</div>
		<div class="limiteFooter">
			<span class="btnLimite" @click="jumpwqxsyf">往期限时一分 &gt; &gt; &gt; &gt;</span>
			<!-- <div class="limiteArr">
				<img src="../../assets/img/arr.png" alt="">
			</div> -->
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				bookLists: [{
						imgUrl: '../../assets/img/bookName.png',
						bookName: '谁动了我的账号',
						jianjie: '一句话简介...'
					},
					{
						imgUrl: '../../assets/img/bookName.png',
						bookName: '谁动了我的账号',
						jianjie: '一句话简介...'
					},
					{
						imgUrl: '../../assets/img/bookName.png',
						bookName: '谁动了我的账号',
						jianjie: '一句话简介...'
					},
					{
						imgUrl: '../../assets/img/bookName.png',
						bookName: '谁动了我的账号',
						jianjie: '一句话简介...'
					}
				],
				yanqing: [],
				chunai: [],
				yansheng: [],
				book_ids: ''
			}
		},
		created() {
			this.get_one_cent();
		},
		methods: {
			jumpwqxsyf() {
				// 往期限时一分界面
				this.$router.push('/gdyanqingtit');
			},

			get_one_cent() {
				this.$axios.post(this.$api.one_cent).then(res => {
					if (res.status == 200) {
						console.log(res, '限时一分')
						this.yanqing = res.data.data.yanqing;
						this.chunai = res.data.data.chunai;
						this.yansheng = res.data.data.yansheng

					}
				})
			},
			// 收藏
			toCollect(val) {
				let yanqings = []
				for (let i = 0; i < this.yanqing.length; i++) {
					var id = this.yanqing[i].book_id
					yanqings.push(id)
				}
				let chunais = []
				for (let i = 0; i < this.chunai.length; i++) {
					var id = this.chunai[i].book_id
					chunais.push(id)
				}
				let yanshengs = []
				for (let i = 0; i < this.yansheng.length; i++) {
					var id = this.yansheng[i].book_id
					yanshengs.push(id)
				}

				if (val == 'yanqing') {
					this.book_ids = yanqings.join(',')
				} else if (val == 'chunai') {
					this.book_ids = chunais.join(',')
				} else if (val == 'yansheng') {
					this.book_ids = yanshengs.join(',')
				}

				this.$axios.post(`${this.$api.xianmian_collect}?books_ids=${this.book_ids}`).then(res => {
					if (res.data.code == 1) {
						Toast('收藏成功');
					} else {
						Toast('收藏失败');
					}
				})
			},
			// 跳转详情页
			jumpBookinfo(val) {

				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						getSecond_tab: 4,
						getFirstvalue_tab: 0,
					}
				})
			},
			//作者专栏
			toZz(val) {
				this.$router.push({
					path: '/autherZl',
					query: {
						user_id: val
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.xianshimianfeiBox {
		padding-top: 60px;
		background-color: #fff;
		overflow-y: scroll;
		height: calc(100vh - 220px);
	}

	.timeBox {
		height: 80px;
		display: flex;
		background-color: #fff;

		.timeLimit {
			flex: 1;
			line-height: 80px;
			display: flex;

			div {
				flex: 1;
				position: relative;

				h4 {
					color: #ff4081;
					font-size: 32px;
					/*px*/
					padding-left: 16px;
				}

				.xsyficon01 {
					width: 90%;
					position: absolute;
					top: -35%;
					left: -16px;
				}

				.xsyficon02 {
					width: 50px;
					position: absolute;
					top: 5px;
					right: -10px;
					vertical-align: middle;
				}
			}

			.xstime {
				flex: 1;
				display: inline-block;
				margin-left: 5px;
				position: relative;

				span {
					padding: 0 10px;
					color: #ff4081;
					font-size: 32px;
					/*px*/
				}

				.xsyficon03 {
					width: 40%;
					position: absolute;
					top: 10%;
					right: -70px;
				}
			}
		}

		.btn_sc {
			flex: 1;
			position: relative;

			button {
				position: absolute;
				top: 50%;
				right: 16px;
				transform: translateY(-50%);
				outline: none;
				border: 0;
				border: 1px solid #fec6d5;
				/*no*/
				border-radius: 28px;
				padding: 0px 20px;
				padding-top: 5px;
				line-height: 40px;
				background-color: #fff8fa;
				color: #fa7298;
				font-size: 26px;
				/*px*/
			}
		}
	}


	.hotBook {
		background-color: #fff;
		padding: 0 16px;

		.hotBookNavBar {
			display: flex;
			justify-content: space-between;
			padding: 10px 0px;

			.hotBookTitle {
				font-size: 30px;
				/*px*/
				font-weight: 700;
				padding-left: 10px;
				margin: 0;
				margin-bottom: 10px;
				color: #ff4081;
			}

			.btn_sc {
				flex: 1;
				position: relative;

				button {
					position: absolute;
					top: 50%;
					right: 0px;
					transform: translateY(-50%);
					outline: none;
					border: 0;
					border: 1px solid #fec6d5;
					/*no*/
					border-radius: 28px;
					padding: 0px 20px;
					padding-top: 5px;
					line-height: 40px;
					background-color: #fff8fa;
					color: #fa7298;
					font-size: 26px;
					/*px*/
				}
			}
		}

		.bookLishBox {
			background-color: #fff;
			overflow: hidden;
			height: 100%;
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			a {
				text-decoration: none;
				color: #3d3d3d;
				float: left;
				width: calc((100vw - 32px) / 4);
				text-align: center;
				font-size: 16px;
				/*px*/
				margin-bottom: 20px;

				img {
					width: 155px;
					height: 220px;
					/*px*/
					-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
				}

				.bookName,
				.jianjie {
					overflow: hidden;
					white-space: nowrap;
					// text-overflow: ellipsis;
					padding: 0 10px;
					margin: 0;
				}

				.bookName {
					padding-top: 5px;
					font-size: 30px;
					/*px*/
					color: #000;
				}

				.jianjie {
					color: #000;
					font-size: 24px;
					/*px*/
					padding-top: 10px;
					opacity: 0.4;
				}
			}
		}

	}


	.limiteFooter {
		display: flex;
		// justify-content: space-between;
		background-color: #fff;
		line-height: 80px;
		padding: 0 16px;

		.btnLimite {
			flex: 1;
			text-align: center;
			font-size: 30px;
			/*px*/
			color: #ff70a0;
		}

		.limiteArr {
			img {
				transform: rotate(270deg);
				width: 32px;
			}
		}
	}
</style>
